<template>
  <v-footer class="pa-3" flat :dark="contrastMode">
    <div class="content">{{$t("FOOTER.TEXT")}} &copy; {{ new Date().getFullYear() }}</div>
  </v-footer>
</template>

<script>
export default {
  name: "Footer",
  props: {
    contrastMode: Boolean
  }
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  text-align: right;
  font-size: 1.4rem;
}
</style>